import { SET_REPORTING_CONFIG } from '../types/reporting'

const initState = {
  reporting: {},
  lastModified: new Date().getTime(),
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_REPORTING_CONFIG:
      return { ...state, reporting: action.payload, lastModified: new Date().getTime() }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reporting.js